import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useFormik} from "formik";
import * as Yup from "yup";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {loginCheck} from "../../../../api/auth";
import {twoFactorUuidRequested} from "../../../../store/actions/auth";
import {MDBAnimation} from "mdbreact";
import {Button} from "react-bootstrap";

const initialValues = {
    username: "",
    password: "",
};

const Login = (props) => {
    const {intl} = props;
    const [loading, setLoading] = useState(false);

    // Validation Schema
    const LoginSchema = Yup.object().shape({
        username: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
        password: Yup.string()
            .min(3, "Minimum 3 symbols")
            .max(50, "Maximum 50 symbols")
            .required(
                intl.formatMessage({
                    id: "AUTH.VALIDATION.REQUIRED_FIELD",
                })
            ),
    });

    const enableLoading = () => {
        setLoading(true);
    };

    const disableLoading = () => {
        setLoading(false);
    };

    const getInputClasses = (fieldname) => {
        if (formik.touched[fieldname] && formik.errors[fieldname]) {
            return "is-invalid";
        }

        if (formik.touched[fieldname] && !formik.errors[fieldname]) {
            return "is-valid";
        }

        return "";
    };

    const formik = useFormik({
        initialValues,
        validationSchema: LoginSchema,
        onSubmit: (values, {setStatus, setSubmitting}) => {
            enableLoading();

            // check credentials and get 2FA uuid
            loginCheck(values.username, values.password)
                .then(({data: {twoFactorUuid}}) => {
                    disableLoading();

                    props.twoFactorUuidRequested(twoFactorUuid);
                })
                .catch(() => {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                        intl.formatMessage({
                            id: "AUTH.VALIDATION.INVALID_LOGIN",
                        })
                    );
                });
        },
    });

    formik.getFieldProps("password")

    return (
        <>
            <Link to="/" className="mb-15 text-center">
                <MDBAnimation type="fadeInUp">
                    <img src={'/media/logos/optimumdesk-logo.svg'} alt="Od Logo"
                         className="max-h-75px"
                         height="75"/>
                </MDBAnimation>
            </Link>
            <div className="login-form login-signin"
                 id="login_signin_form">

                <div className="text-center mb-10 mb-lg-20">
                    <MDBAnimation type="fadeInUp">
                        <h2 className="font-weight-bold">
                            <FormattedMessage id="AUTH.LOGIN.TITLE"/>
                        </h2>
                        <p className="text-muted font-weight-bold">
                            Enter your username and password
                        </p>
                    </MDBAnimation>
                </div>

                <form
                    onSubmit={formik.handleSubmit}
                    className="form fv-plugins-bootstrap fv-plugins-framework"
                >
                    {formik.status &&
                    <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                        <div className="alert-text font-weight-bold">{formik.status}</div>
                    </div>}

                    <MDBAnimation type="fadeInUp">
                        <div className="form-group fv-plugins-icon-container">
                            <input
                                placeholder="Username"
                                type="text"
                                className={`form-control form-control-solid h-auto py-5 px-6 
                                    ${getInputClasses("username")}`
                                }
                                name="username"
                                onChange={formik.handleChange}
                                value={formik.values.username}
                            />

                            {formik.touched.username && formik.errors.username ? (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">{formik.errors.username}</div>
                                </div>
                            ) : null}
                        </div>
                    </MDBAnimation>

                    <MDBAnimation type="fadeInUp">
                        <div className="form-group fv-plugins-icon-container">
                            <input
                                placeholder="Password"
                                type="password"
                                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                                    "password"
                                )}`}
                                name="password"
                                onChange={formik.handleChange}
                                value={formik.values.password}
                            />
                            {formik.touched.password && formik.errors.password ? (
                                <div className="fv-plugins-message-container">
                                    <div className="fv-help-block">{formik.errors.password}</div>
                                </div>
                            ) : null}
                        </div>
                    </MDBAnimation>

                    <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                        <MDBAnimation type="fadeInDown">
                            <Link
                                to="/auth/forgot-password"
                                className="text-dark-50 text-hover-primary my-3 mr-2"
                                id="login_forgot"
                            >
                                <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON"/> ?
                            </Link>
                        </MDBAnimation>

                        <MDBAnimation type="fadeInDown">
                            <Button
                                id="login_signin_submit"
                                type="submit"
                                disabled={formik.isSubmitting}
                                className={`btn btn-primary font-weight-bold px-9 py-4 my-3 waves-effect waves-light`}
                            >
                                <span>Sign In</span>

                                {loading && <span className="ml-3 spinner spinner-white"></span>}
                            </Button>
                        </MDBAnimation>
                    </div>
                </form>
                {/*end::Form*/}
            </div>
        </>
    );
}

export default injectIntl(connect(null, {twoFactorUuidRequested})(Login));
